import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconStaticReminderAnniversary = function IconStaticReminderAnniversary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 41"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "#00204D",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M2.86 2.79v3.721M1 4.651h3.72m2.792 30.698v3.72M5.651 37.21h3.721M39.14 25.116v3.721m-1.86-1.86H41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.512,
    cy: 0.93,
    r: 0.93,
    fill: "#00204D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.349,
    cy: 34.419,
    r: 0.93,
    fill: "#00204D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.86,
    cy: 29.768,
    r: 0.93,
    fill: "#00204D"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    d: "M12.648 21.938c-1.808-.865-1.506-4.443-1.13-6.124h7.156c-.376 1.44-1.356 4.611-2.26 5.764-.904 1.152-2.887.72-3.766.36m17.882-.558c1.322-1.315.157-5.244-.591-7.044l-6.105 1.391c.687 1.532 2.327 4.875 3.39 5.984 1.064 1.108 2.647.241 3.305-.331"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "#00204D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m12.664 8.132.142-.766c.304-1.556 1.554-.67 4.3.145 2.821.842 2.663 2.09 2.663 2.09s-.05 1.492-1.915 7.334c-.866 2.694-1.825 4.083-2.644 4.803-1.119.974-2.657.585-3.384-.838-1.13-2.158-.545-5.127-.545-5.127l.88-4.567"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "#00204D",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m11.232 29.768 1.86-7.442"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "#00204D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m8.348 29.193 5.675 1.505m-1.86-15.814h5.581m12.546-1.846.386 2.648s.482 2.933-.721 5.012c-.776 1.371-2.326 1.701-3.411.707-.794-.733-1.723-2.129-2.477-4.801-1.663-5.794-1.662-7.26-1.662-7.26s-.135-1.23 2.715-1.961c2.771-.708 4.07-1.534 4.302.003l.328 2.246m-.131 19.349-1.23-6.66M32.582 29l-5.442 1.239m2.535-15.742-6.048.323"
  }));
};